import { SelfServeNodeLevel, SelfServeNodeLevels } from "../types";

import { useSelectedNode } from "./useSelectedNode";

export const useCurrentNodeHasMoreLevels = (level?: SelfServeNodeLevel) => {
  const nodes = useSelectedNode();
  let currentNode = level ? nodes[`level${level}Node`] : undefined;

  if (!level) {
    for (let level = SelfServeNodeLevels.length - 1; level >= 0; level--) {
      currentNode = nodes[`level${level}Node` as keyof typeof nodes];
      if (currentNode) {
        break;
      }
    }
  }

  const hasMoreIssueLevels =
    currentNode?.children !== undefined && currentNode.children.length > 0;

  return {
    hasMoreIssueLevels,
  };
};
